// Shared purple palette for the "plan" chips (crown tag + Enterprise chips)
// used across the signature pricing landing and the blocked-control callouts.
// The chips differ in size and background, so this shares the colors only, not
// a full component.
export const PRICING_CHIP = {
  text: '#531DAB',
  border: '#D3ADF7',
  tintedBg: '#F9F0FF',
} as const;
